import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./VerifyEmail.css";
import Spinner from "../components/Spinner";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const email = new URLSearchParams(useLocation().search).get("email");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/auth/verify-email`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code })
      }
    );
    setLoading(false);
    if (!res.ok) {
      const { message } = await res.json();
      return setError(message);
    }

    setSuccess(true);
  };

  const handleContinue = () => {
    navigate("/login");
  };

  return (
    <div className="verify-container">
      <div className="verify-box">
        <h2>Verificá tu correo</h2>
        <p>
          Te enviamos un código a <strong>{email}</strong>. Ingresalo abajo:
        </p>
        <form onSubmit={submit}>
          <input
            type="text"
            placeholder="Código de 6 dígitos"
            value={code}
            onChange={e => setCode(e.target.value)}
            maxLength={6}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? <Spinner size={18} /> : "Verificar"}
          </button>

        </form>
        {error && <p className="error-text">{error}</p>}
      </div>

      {success && (
        <div className="modalOverlay">
          <div className="modalBox">
            <h3>✅ Verificación exitosa</h3>
            <p>¡Tu cuenta ya está activa! Te redirigimos para iniciar sesión.</p>
            <button onClick={handleContinue} className="btnPrimary">
              Ir a Iniciar Sesión
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
